import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import AboutPage from "@/pages/AboutPage";
import PublicPage from "@/pages/PublicPage";
import EventsPage from "@/pages/EventsPage";
import { DownloadsPage, VideosPage } from "@/pages/MediaPages";
import { ContactPage, MembershipPage } from "@/pages/FormPages";
import AuthCallback from "@/pages/AuthCallback";
import AdminPage from "@/pages/admin/AdminPage";
import LoginPage from "@/pages/auth/LoginPage";
import RegisterPage from "@/pages/auth/RegisterPage";
import AccountPage from "@/pages/account/AccountPage";
import GalleryPage from "@/pages/GalleryPage";
import SetupPasswordPage from "@/pages/auth/SetupPasswordPage";
import TicketPage from "@/pages/TicketPage";
import CertificatePage from "@/pages/CertificatePage";
import PostPage from "@/pages/PostPage";
import { AuthProvider } from "@/hooks/useAuth";
import { SettingsProvider } from "@/hooks/useSettings";

function AppRoutes() {
  const location = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/leadership" element={<PublicPage type="leadership" title="Leadership" description="Meet the people leading DCEA today." />} />
      <Route path="/members" element={<PublicPage type="members" title="Members" description="The professionals who make up our network." canSearch />} />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/news" element={<PublicPage type="news" title="News & Notices" description="The latest from the DCEA community." canSearch />} />
      <Route path="/news/:postId" element={<PostPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/gallery/:albumId" element={<GalleryPage />} />
      <Route path="/videos" element={<VideosPage />} />
      <Route path="/sponsors" element={<PublicPage type="sponsors" title="Sponsors & partners" description="The organisations that help DCEA do more for the profession." />} />
      <Route path="/downloads" element={<DownloadsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/membership" element={<MembershipPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/setup-password" element={<SetupPasswordPage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/ticket/:code" element={<TicketPage />} />
      <Route path="/certificate/:code" element={<CertificatePage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <AppRoutes />
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
